import { render, staticRenderFns } from "./edit-foodName.vue?vue&type=template&id=ce35784a&scoped=true&"
import script from "./edit-foodName.vue?vue&type=script&lang=js&"
export * from "./edit-foodName.vue?vue&type=script&lang=js&"
import style0 from "./edit-foodName.vue?vue&type=style&index=0&id=ce35784a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce35784a",
  null
  
)

export default component.exports